import React from "react";
import { Barras, COLORES, Columnas, GRIS, Kpis, Mezcla, Pagina, Tarjeta, fmtM, fmtN, fmtP, useDatos, usePeriodo } from "./comun";

function ReporteVentas() {
  const periodo = usePeriodo();
  const { datos: d, error } = useDatos(`/ventas/${periodo.inicio}/${periodo.fin}`);
  const k = d?.kpis;
  return (
    <Pagina titulo="Ventas" subtitulo="Que se vende, a quien y como va contra el año pasado" periodo={periodo} error={error} cargando={!d}>
      {d && <>
        <Kpis items={[
          { t: "Venta neta", v: fmtM(k.venta), d: k.variacion === null ? "Sin periodo anterior" : `${k.variacion >= 0 ? "+" : ""}${fmtP(k.variacion)} vs periodo anterior`, tono: k.variacion < 0 ? "baja" : "sube" },
          { t: "Botellas", v: fmtN(k.botellas), d: `${fmtN(k.cajas)} cajas` },
          { t: "Precio por botella", v: fmtM(k.precioBotella) },
          { t: "Ticket promedio", v: fmtM(k.ticket), d: `${fmtN(k.notas)} notas` },
          { t: "Clientes activos", v: fmtN(k.clientes) },
          { t: "Devoluciones", v: fmtM(k.devoluciones), d: `${fmtP(k.pctDevoluciones)} de la venta` },
        ]} />
        <div className="rp-grid">
          <Tarjeta titulo="Venta por mes" nota="Ultimos 12 meses contra el año anterior" ancho>
            <Columnas datos={d.meses} series={[{ key: "anterior", label: "Año anterior", color: GRIS }, { key: "actual", label: "Este año", color: COLORES[0] }]} />
          </Tarjeta>
          <Tarjeta titulo="Vinos mas vendidos"><Barras datos={d.topVinos} extra={(x) => `${fmtN(x.botellas)} bot.`} /></Tarjeta>
          <Tarjeta titulo="Mejores clientes"><Barras datos={d.topClientes} extra={(x) => `${fmtN(x.botellas)} bot.`} /></Tarjeta>
          <Tarjeta titulo="Por tipo de vino"><Mezcla datos={d.porTipo} /></Tarjeta>
          <Tarjeta titulo="Por tipo de cliente"><Mezcla datos={d.porTipoCliente} /></Tarjeta>
          <Tarjeta titulo="Por vendedor"><Barras datos={d.porVendedor} /></Tarjeta>
          <Tarjeta titulo="Perfil kosher" nota="Mevushal, Pesaj y certificacion">
            <Mezcla datos={d.kosher.mevushal} /><Mezcla datos={d.kosher.pesaj} /><Mezcla datos={d.kosher.certificacion} />
          </Tarjeta>
        </div>
      </>}
    </Pagina>
  );
}
export default ReporteVentas;
